<template>
  <div class="header-top container-fluid">
      <div class="row">
          <div class="col-sm-12">
              <b-navbar-brand href="#">
                  <a href="/" class="navbar-brand logo">
                      <img src="../assets/DoellkenProfilesBrandLogo.svg" height="70" alt="Doellken-Profiles B2B">
                  </a>
              </b-navbar-brand>
              <b-navbar class=" bg-none"  toggleable="lg" type="dark" >
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-collapse id="nav-collapse" is-nav>
                      <!-- Right aligned nav items -->
                      <b-navbar-nav class="ml-auto">
                          <language-changer />
                          <currency-picker />
                          <b-nav-item>
                              <b-button size="sm" class="my-sm-0" >  <router-link
                                      class="nav-link"
                                      to="/products"
                              >
                                  {{ $t('navbar.products') }}
                              </router-link>
                              </b-button>
                          </b-nav-item>
                          <b-nav-item>
                              <b-button size="sm" class="my-sm-0" >
                                  <router-link
                                          class="nav-link"
                                          :to="{ path: '/customers/' + this.cardCode} "
                                  >
                                      {{ $t('navbar.account') }}
                                  </router-link>
                              </b-button>
                          </b-nav-item>
                          <b-nav-item>
                              <b-button size="sm" class="my-sm-0" >
                                  <a
                                          class="nav-link router-link"
                                          style="cursor:pointer"
                                          @click="onLogout"
                                  >
                                      {{ $t('auth.logout') }}
                                  </a>
                              </b-button>
                          </b-nav-item>
                      </b-navbar-nav>
                  </b-collapse>
              </b-navbar>
          </div>

          <div class="col-sm-12">
              <cart-summary />
          </div>
      </div>

  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
    import CartSummary from "./CartSummary";
    import LanguageChanger from './LanguageChanger';
    import CurrencyPicker from './CurrencyPicker';
    export default {
        name: 'Header',
        components: {CartSummary, CurrencyPicker, LanguageChanger},
      data: function () {
        return {
          cardCode: '',
        };
      },
      mounted () {
        this.cardCode = this.user.cardCode;
      },
      computed: {
        ...mapState('auth', ['user']),
      },
      methods: {
        ...mapActions('auth', [
          'Logout'
        ]),
        onLogout() {
          this.Logout().then(() => {
            this.$router.push('/')
          })
        }
      }
    };
</script>

<style scoped>
    @import "../assets/styles/general.css";
    @import "../assets/styles/header.css";
</style>
